import { useEffect, useState } from "react";
import api from "../api";
import { ReviewRequestButton } from "./ReviewRequest";

export default function ReviewsPanel() {
  const [data, setData] = useState(null);
  const load = () => api.get("/appointments/reviews/pending", { noCache: true }).then((r) => setData(r.data)).catch(() => {});
  useEffect(() => { load(); }, []);

  if (!data) return null;
  const { stats, pending } = data;
  const received = data.received || [];
  const pct = stats.clients_total ? Math.round((stats.clients_with_review / stats.clients_total) * 100) : 0;

  const confirm = async (id, p) => {
    try { await api.post(`/appointments/reviews/${id}/confirm${p !== null && p !== undefined ? `?p=${p}` : ""}`); load(); }
    catch (e) { alert(e.response?.data?.detail || e.message); }
  };

  return (
    <div className="panel" data-testid="reviews-panel" style={{ marginTop: 8 }}>
      <div className="toolbar" style={{ marginBottom: 6 }}>
        <h3 style={{ margin: 0 }}>⭐ Recensioni Google</h3>
        <div className="spacer" />
        <span data-testid="reviews-counter" style={{ fontWeight: 700, fontSize: 18 }}>
          {stats.clients_with_review} <span className="muted" style={{ fontWeight: 400, fontSize: 13 }}>su {stats.clients_total} clienti ({pct}%)</span>
        </span>
      </div>
      {pending.length === 0 ? (
        <p className="muted" style={{ margin: 0, fontSize: 13 }} data-testid="reviews-pending-empty">Nessuna valutazione 5★ in attesa di recensione Google.</p>
      ) : (
        <>
          <p className="muted" style={{ marginTop: 0, fontSize: 13 }}>
            {pending.length} {pending.length === 1 ? "contatto ha" : "contatti hanno"} dato 5★ dopo l'incontro ma la recensione Google non risulta ancora: sollecita con un click.
          </p>
          <table style={{ fontSize: 13 }} data-testid="reviews-pending-table">
            <thead><tr><th>Contatto</th><th>Incontro</th><th>Recapiti</th><th></th></tr></thead>
            <tbody>
              {pending.map((r) => (
                <tr key={`${r.id}-${r.p ?? "m"}`}>
                  <td>{r.name || "—"}{r.p !== null && r.p !== undefined && <span className="muted" style={{ fontSize: 11 }}> (partecipante)</span>}</td>
                  <td className="muted" style={{ whiteSpace: "nowrap" }}>{String(r.date || "").split("-").reverse().join("/")} {r.time || ""}</td>
                  <td className="muted" style={{ wordBreak: "break-all" }}>{[r.email, r.phone].filter(Boolean).join(" · ") || "—"}</td>
                  <td style={{ whiteSpace: "nowrap", textAlign: "right" }}>
                    <ReviewRequestButton name={r.name} email={r.email} phone={r.phone} />
                    <button className="btn sm" style={{ marginLeft: 6 }} onClick={() => confirm(r.id, r.p)} data-testid={`review-confirm-${r.id}${r.p ?? ""}`} title="La recensione è arrivata su Google (o non vuoi più sollecitare): togli dalla lista">✔ Ricevuta</button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </>
      )}
      {received.length > 0 && (
        <details style={{ marginTop: 10 }} data-testid="reviews-received-details">
          <summary className="muted" style={{ cursor: "pointer", fontSize: 13 }}>
            📝 Voti e commenti ricevuti dal questionario ({received.length})
          </summary>
          <table style={{ fontSize: 13, marginTop: 6 }} data-testid="reviews-received-table">
            <thead><tr><th>Contatto</th><th>Data</th><th>Voto</th><th>Commento</th><th></th></tr></thead>
            <tbody>
              {received.map((r, i) => (
                <tr key={i} data-testid={`review-received-${i}`}>
                  <td>{r.name}</td>
                  <td className="muted" style={{ whiteSpace: "nowrap" }}>{String(r.date || "").split("-").reverse().join("/")}</td>
                  <td style={{ whiteSpace: "nowrap", color: (r.rating || 0) >= 5 ? "#f59e0b" : (r.rating || 0) >= 4 ? "#a3e635" : "#f87171" }}>
                    {"★".repeat(r.rating || 0)}{"☆".repeat(Math.max(0, 5 - (r.rating || 0)))}
                  </td>
                  <td>{r.feedback ? r.feedback : <span className="muted">—</span>}</td>
                  <td>
                    <button className="btn sm danger" title="Elimina questo voto/commento" data-testid={`review-del-${i}`}
                      onClick={async () => {
                        if (!window.confirm(`Eliminare il voto di ${r.name}?`)) return;
                        await api.delete(`/appointments/reviews/${r.appt_id}/entry${r.p != null ? `?p=${r.p}` : ""}`);
                        load();
                      }}>🗑</button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </details>
      )}
    </div>
  );
}
